import { Injectable } from '@angular/core';
import { LegacyFeatureFlagService as ClaraFeatureFlagService } from '@uzurv/clara';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LegacyFeatureFlagService {
  private _isCreditCardValidationEnabled: boolean = false;

  constructor(private claraFeatureFlagService: ClaraFeatureFlagService) {}

  getFeatureFlags(): void {
    // Credit Card Validation
    this.claraFeatureFlagService
      .isCreditCardValidationEnabled()
      .pipe(
        map(isCreditCardValidationEnabled => {
          this._isCreditCardValidationEnabled = isCreditCardValidationEnabled;
        })
      )
      .subscribe();
  }

  isCreditCardValidationEnabled(): boolean {
    return this._isCreditCardValidationEnabled;
  }
}
